var $ = require('jquery');
var videojs = require('video.js');
var options = require('./video-options');
var init = require('./video-init');

require('videojs-contrib-hls');

/**
 * Standalone video player.
 *
 * Usage:
 *   var videoPlayer = new VideoPlayer;
 *   videoPlayer.setup(elements);
 *
 */
module.exports = function () {

    /**
     * Keep track of all player instances.
     */
    var players = [];

    /**
     * Loop through all elements and initialise the video player.
     *
     * elements -> one or more elements, optionally a class name
     * customOptions -> custom options that extend the default options
     */
    this.setup = function (elements, customOptions) {

        if (customOptions) {
            $.extend(options, customOptions);
        }

        elements = (typeof elements !== 'string' && elements instanceof $) ? elements : $('.'+elements);

        elements.each(function(index, element) {
            var videoId = $(element).attr('id');
            var player;

            if (videojs.getPlayers()[videoId]) {
                videojs.getPlayers()[videoId].dispose();
            }

            player = init(videoId, options);

            players.push(player);
        });

        return players;
    };

    /**
     * Pause video playback.
     */
    this.pause = function() {

        $.each(players, function(index, player) {
            player.pause();
        });

    };
}
